import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-consolidado-aplicacao`

    return {
        index() {
            return repository.get(baseUrl)
        },
        getSalasVacinacao(queryParms) {
            return repository.get(`${baseUrl}/sala-vacinacao?${urlUtil.serialize(queryParms)}`)
        },
        getVacinas(queryParms) {
            return repository.get(`${baseUrl}/vacina?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}